import { useEffect } from 'react';

interface JsonLdProps {
  data: object;
  id: string;
}

export default function JsonLd({ data, id }: JsonLdProps) {
  const scriptId = `jsonld-${id}`;

  useEffect(() => {
    const existing = document.getElementById(scriptId);
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = scriptId;
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById(scriptId);
      if (s) s.remove();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scriptId]);

  return null;
}
